import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Page, Note, Uniter } from "../../../helbest";
import { TComma } from "../../../base/utils";
import { API } from "../../../request/api";
import styles from "./Orders.module.css";
import HeaderBack from "../../../helbest/HeaderBack/HeaderBack";
import { ReactComponent as EmptyBoxIcon } from "./../../../assets/svg/empty-box.svg";
import Loading from "../../components/Loading/Loading";
import { useLangNavigate } from "../../../hooks/useLangNavigate";

const Orders = (props) => {
  const navigate = useLangNavigate();
  const [loading, set_loading] = useState(true);
  const [data, set_data] = useState([]);

  const check_user = () => {
    if (!props.Login.is_login) {
      navigate("/login/d/");
    }
  };

  const _GET_ORDERS = () => {
    set_loading(true);
    API.get
      .userOrders()
      .then((response) => {
        if (response.success) {
          set_loading(false);
          set_data(response.data);
        } else {
          set_loading(false);
          Note.error(response.message);
        }
      })
      .catch((error) => {
        set_loading(false);
        console.log("Error : ", error);
      });
  };

  useEffect(() => {
    _GET_ORDERS();
  }, []);

  useEffect(() => {
    check_user();
    // eslint-disable-next-line
  }, [props.Login.is_login]);

  return (
    <Page
      className="page-profile"
      mobileContainer
      headerFix
      // title="سفارشات من"
      back
      address="/profile/"
      customHeader={<HeaderBack title="My Orders" />}
    >
      {!!data && data.length === 0 && !loading && (
        <div className={`${styles.EmptyContainer} ${styles.CenterBase}`}>
          <EmptyBoxIcon className={styles.EmptyBoxIcon} />
          <div className={styles.EmptyText}>No Orders Found</div>
        </div>
      )}
      {loading ? (
        <div className="text-center mt-5">
          <Loading />
        </div>
      ) : null}
      <div className="factors-holder factors-scroll page-factor-factors-container">
        {data?.map((x, i) => (
          <div key={i}>
            <div className={styles.FactorsIconContainer}>
              <div className="factors-item page-factor-factors-item" key={i}>
                <div className="w-full order-page-item-feature-container">
                  <label>Order Date:</label>
                  <span className={`w-130 ${styles.DateTime}`}>
                    <strong className="pa-l-5"> {x.date}, </strong>
                    <strong> {x.time} </strong>
                  </span>
                </div>
                <div className="w-full order-page-item-feature-container">
                  <label>Paid Amount :</label>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignContent: "center",
                    }}
                  >
                    <div className="orders-toman-price">
                      <Uniter unit="OMR" isBold>
                        {TComma(x.payable_amount)}
                      </Uniter>
                      {/* <div style={{transfor: 'translateY(-2px)'}} className="orders-toman-text">OMR</div>
                          {TComma(x.payable_amount)}{" "} */}
                    </div>
                  </div>
                </div>
                <hr className="global-hr" />
                <div
                  className="order-summary-btn"
                  onClick={() => navigate(`/order/${x.id}/`)}
                >
                  <span className={styles.OrderDetails}>Order Details</span>
                  {/* <img style={{transform: 'rotate(180deg)'}} className="hei-15" src={IconChevronLeft} alt="<" /> */}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Page>
  );
};

// class Orders extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       loading: true,
//       data: [],
//     };
//     this.check_user();
//   }

//   check_user() {
//     if (!this.props.Login.is_login) {
//       navigate("/login/d/");
//     }
//   }

//   componentDidMount() {
//     this._GET_ORDERS();
//   }

//   _GET_ORDERS() {
//     this.setState({ loading: true });
//     API.get.userOrders()
//       .then((response) => {
//         if (response.success) {
//           this.setState({ loading: false, data: response.data });
//         } else {
//           this.setState({ loading: false });
//           Note.error(response.message);
//         }
//       })
//       .catch((error) => {
//         this.setState({ loading: false });
//         console.log("Error : ", error);
//       });
//   }

//   render() {
//     return (
//       <Page
//         className="page-profile"
//         mobileContainer
//         headerFix
//         title="سفارشات من"
//         back
//         address="/profile/"
//         showFooter>
//         {
//           (!!this.state.data && this.state.data.length === 0 && !this.state.loading) &&
//           <div className={`${styles.EmptyContainer} ${styles.CenterBase}`}>
//             <EmptyBoxIcon className={styles.EmptyBoxIcon} />
//             <div className={styles.EmptyText}>اعتباری یافت نشد</div>
//           </div>
//         }
//         {this.state.loading ? (
//           <div className="text-center mt-5" style={{marginTop: 20}}>
//             <Spin className={`${styles.Spin} red`} />
//           </div>
//         ) : null}
//         <div className="factors-holder factors-scroll page-factor-factors-container">
//           {this.state.data?.map((x, i) => (
//             <div key={i}>
//               <div className={styles.FactorsIconContainer}>
//                 <div className="factors-item page-factor-factors-item" key={i}>
//                   <div className="w-full order-page-item-feature-container">
//                     <label>Order Date:</label>
//                     <span className="w-130">
//                       <span className="pa-l-5"> {x.time} </span>
//                       <span> {x.date} </span>
//                     </span>
//                   </div>
//                   <div className="w-full order-page-item-feature-container">
//                     <label>Paid Amount :</label>
//                     <div style={{display: "flex", flexDirection: 'row', justifyContent: 'center', alignContent: 'center'}}>
//                       <div className="orders-toman-price">
//                       <div style={{transfor: 'translateY(-2px)'}} className="orders-toman-text">OMR</div>
//                         {TComma(x.payable_amount)}{" "}
//                       </div>
//                     </div>
//                   </div>
//                   <hr className="global-hr" />
//                   <div
//                     className="w-full order-summary-btn"
//                     onClick={() => navigate(`/order/${x.id}/`)}>
//                     <span>Order Details</span>
//                     <img style={{transform: 'rotate(180deg)'}} className="hei-15" src={IconChevronLeft} alt="<" />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </Page>
//     );
//   }
// }

const mstp = (state) => ({
  Login: state.Login,
  Cart: state.Cart,
});
export default connect(mstp)(Orders);
